import React from "react"
import styled from "styled-components"
import { AngleLeftIcon } from "client/components"

interface ArrowProps {
    isExpanded: boolean
}
interface SubItemWrapperProps {
    isExpanded: boolean
    childrenLength: number
}

const subItemHeight = 30

export const ProjectMenuItem = styled.div<{
    isActive: boolean
    fitContent?: boolean
}>`
    display: flex;
    flex-shrink: 0;
    height: ${(props) => (props.fitContent ? "fit-content" : "36px")};
    border-bottom: 1px solid ${(props) => props.theme.projectMenuItemBorderBottomColor};
    background: ${(props) => (props.isActive
        ? props.theme.projectMenuItemActiveBackground
        : props.theme.projectMenuItemBackground)};
    transition: ${(props) => props.theme.defaultTransition};

    &:hover {
        background: ${(props) => (props.isActive
        ? props.theme.projectMenuItemActiveBackground
        : props.theme.projectMenuItemHoverBackground)};
        transition: ${(props) => props.theme.defaultTransition};
    }

    & > a {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: ${(props) => (props.fitContent ? "0px 5px 0px 5px" : "0px 5px 0px 10px")};
        user-select: none;
        cursor: pointer;
        font-size: ${(props) => props.theme.fontSizes.sm}px;
        font-family: ${(props) => props.theme.openSans};
        color: ${(props) => props.theme.projectMenuItemColor};

        &:hover {
            color: ${(props) => props.theme.projectMenuItemColor};
            text-decoration: none;
        }
    }
`
export const ProjectMenuSubItemWrapper = styled.div<SubItemWrapperProps>`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    height: ${(props) => (props.isExpanded
        ? props.childrenLength * subItemHeight
        : 0)}px;
    overflow: hidden;
    transition: ${(props) => {
        const delay = props.childrenLength * 0.15
        return (delay > 0.5) ? 0.5 : delay
    }}s ease;
`
export const ProjectMenuSubItem = styled.div<{
    isActive: boolean
}>`
    display: flex;
    flex-shrink: 0;
    height: ${subItemHeight}px;
    background: ${(props) => (props.isActive
        ? props.theme.projectMenuSubItemActiveBackground
        : props.theme.projectMenuSubItemBackground)};
    transition: ${(props) => props.theme.defaultTransition};

    &:hover {
        background: ${(props) => (props.isActive
        ? props.theme.projectMenuSubItemActiveBackground
        : props.theme.projectMenuSubItemHoverBackground)};
        transition: ${(props) => props.theme.defaultTransition};
    }

    & > a {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 0px 10px 0px 25px;
        user-select: none;
        cursor: pointer;
        font-size: ${(props) => props.theme.fontSizes.sm}px;
        font-family: ${(props) => props.theme.openSans};
        color: ${(props) => props.theme.projectMenuSubItemColor};

        &:hover {
            color: ${(props) => props.theme.projectMenuSubItemColor};
            text-decoration: none;
        }
    }
`
export const ProjectMenuItemTitle = styled.span`
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`


export const ProjectMenuLogoWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 50px;
    width: calc(100% - 15px);
`
export const ProjectMenuLogoTitleColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% - 50px);
    padding-left: 5px;
`
export const ProjectMenuLogoTitle = styled.span`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: ${(props) => props.theme.defaultFont};
    font-size: ${(props) => props.theme.fontSizes.sm}px;
    font-weight: 600;
`


const ProjectMenuItemArrowWrapper = styled.span<ArrowProps>`
    width: 15px;
    color: grey;

    & > i {
        transform: rotate(${(props) => (props.isExpanded ? -90 : 0)}deg);
        transition: ${(props) => props.theme.defaultTransition};
    }
`
export const ProjectMenuItemArrow = ({
    isExpanded = false,
}: ArrowProps) => (
    <ProjectMenuItemArrowWrapper isExpanded={isExpanded}>
        <AngleLeftIcon />
    </ProjectMenuItemArrowWrapper>
)
